import { useScrollReveal } from '../../hooks/useScrollReveal';

const trustItems = [
  { icon: 'ri-building-line', label: 'Residential Architecture Studio' },
  { icon: 'ri-pencil-ruler-2-line', label: 'Custom Home Design' },
  { icon: 'ri-hammer-line', label: 'Renovations & Additions' },
  { icon: 'ri-focus-3-line', label: 'Detail-Driven Approach' },
  { icon: 'ri-calendar-check-line', label: 'Est. 2002 · 20+ Years' },
];

export default function TrustBar() {
  const ref = useScrollReveal();

  return (
    <section className="bg-soft-white border-b border-stone">
      <div
        ref={ref}
        className="reveal-on-scroll max-w-none mx-auto px-8 lg:px-16 py-4"
      >
        <div className="flex flex-wrap items-center justify-center gap-0">
          {/* Rating */}
          <div className="flex items-center gap-2 px-6 py-2 border-r border-stone">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-star-fill text-wood text-xs" />
                </div>
              ))}
            </div>
            <span className="font-sans text-[11px] text-warm-gray tracking-wide whitespace-nowrap ml-1">5.0 Rating</span>
          </div>

          {/* Trust items */}
          {trustItems.map((item, i) => (
            <div key={i} className={`flex items-center gap-2.5 px-6 py-2 ${i < trustItems.length - 1 ? 'border-r border-stone' : ''}`}>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-wood text-sm`} />
              </div>
              <span className="font-sans text-[11px] text-warm-gray tracking-wide whitespace-nowrap">{item.label}</span>
            </div>
          ))}

          {/* Location */}
          <div className="flex items-center gap-2 px-6 py-2 border-l border-stone">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-2-line text-wood text-sm" />
            </div>
            <span className="font-sans text-[11px] text-warm-gray tracking-wide whitespace-nowrap">NYC &amp; Westchester, NY</span>
          </div>
        </div>
      </div>
    </section>
  );
}
